import * as React from "react";
import { CSSTransition } from "react-transition-group";
import {
  Grid,
  Typography,
  CircularProgress,
  withStyles,
  Tooltip,
  Snackbar,
  IconButton,
  Tabs,
  Tab,
  Fab,
} from "@material-ui/core";
import { observer } from "mobx-react";
import { ModelMapStore } from "modules/modelMap/ModelMapStore";
import { TakeOffStore } from "modules/takeOff/TakeOffStore";
import UpdateBudgetResorcesTab1Edit from "modules/WBS/components/layouts/UpdateBudgetResorcesTab1Edit";
import UpdateBudgetResorcesTab2 from "modules/WBS/components/layouts/UpdateBudgetResorcesTab2";
import SwipeableViews from "react-swipeable-views";
import Header from "modules/takeOff/components/layouts/Header";
import i18n from "i18n";
//import { Map, Close } from "@material-ui/icons";
import * as _ from "lodash";
import CloseIcon from "@material-ui/icons/Close";
import { WBSStore } from "modules/WBS/WBSStore";

const styles = (theme) => ({
  modal: {
    left: 0,
    zIndex: 2,
    top: 0,
    height: "calc(100vh)",
    width: "100%",
    backgroundColor: "rgba(0,0,0,0.5)",
    position: "absolute" as any,
  },
  container: {
    zIndex: 2,
    height: "calc(100vh - 34px)",
    display: "grid",
    gridTemplateRows: "auto 1fr",
    backgroundColor: "#FFFFFF",
  },
  categoriesTitle: {
    fontFamily: "Roboto",
    fontWeight: 700,
    fontSize: "14px",
    color: "rgba(0, 0, 0, 0.6)",
    paddingRight: "5px",
  },
  inputSelect: {
    fontFamily: "Roboto",
    fontSize: "20px",
    fontWeight: 300,
    width: "790px",
    margin: "0 auto",
    marginTop: "5px",
    // marginBottom: '70px',
    display: "block",
    "& :focus": {
      backgroundColor: "transparent",
    },
  },
  button: {
    background: "#ABC200",
    border: "transparent",
    "&:hover": {
      background: "#92A501",
    },
    "&:disabled": {
      opacity: 0.3,
      border: "transparent",
    },
  },
  input: {
    fontFamily: "Roboto",
    fontSize: "14px",
    fontWeight: 400,
    display: "block",
    "&:focus": {
      backgroundColor: "transparent",
    },
    "&:hover": {
      borderBottom: "1px dotted #000 !important",
    },
    cursor: "pointer",
  },
  transitionEnter: {
    opacity: 0.01,
  },
  transitionEnterActive: {
    opacity: 1,
    transition: "opacity 300ms ease-in",
  },
  transitionLeave: {
    opacity: 1,
  },
  transitionLeaveActive: {
    opacity: 0.01,
    transition: "opacity 300ms ease-in",
  },
  chips: {
    display: "flex" as any,
    flexWrap: "wrap" as any,
    justifyContent: "center" as any,
  },
  chip: {
    margin: "1px 5px",
  },
  tabBar: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    backgroundColor: "#FFFFFF",
  },
  subHeaderBar: {
    display: "flex",
    alignItems: "left",
  },
  tabsRoot: {
    backgroundColor: "#FFFFFF",
    color: "#9E9E9E",
    boxShadow: "unset",
    width: "fit-content",
    fontSize: "12px",
  },
  tabsIndicator: {
    height: 0,
  },
  tabRoot: {
    width: 154,
    minWidth: "unset",
    border: "unset",
    fontWeight: 500,
    "&$tabSelected > :first-child": {
      borderBottom: `3px solid #9FB408`,
      fontWeight: 700,
    },
    "&:hover": {
      color: "#9FB408",
    },
    transition: "all 0.3s ease-in",
  },
  tabSelected: {
    color: "#9FB408",
  },
  tabLabelContainer: {
    padding: "0px",
  },
  tabWrapper: {
    height: "50px",
    display: "block",
    lineHeight: "50px",
    fontFamily: "Raleway",
  },
});

type IProps = {
  classes: any;
};

function TabContainer({ children }) {
  return <Typography component="div">{children}</Typography>;
}

@observer
class UpdateBudgetResources extends React.Component<IProps> {
  handleTabChange = (event, tab) => {
    TakeOffStore.swipeTabComposition = tab;
    if (ModelMapStore.modelMapFormat.length === 0) {
      ModelMapStore.loadModelFormat();
    }
  };

  handleCloseSnack = () => {
    TakeOffStore.openSnack = false;
  };

  render() {
    const { classes } = this.props;
    const tabClasses = {
      root: classes.tabRoot,
      selected: classes.tabSelected,
      labelContainer: classes.tabLabelContainer,
      wrapper: classes.tabWrapper,
    };

    return (
      <CSSTransition
        in={WBSStore.updateComposition}
        enter={true}
        exit={true}
        onExit={() => {
          WBSStore.newCompositionList = [];
          WBSStore.selectedComposition = {};
          TakeOffStore.swipeTabComposition = 0;
        }}
        timeout={300}
        classNames={{
          enter: classes.transitionEnter,
          enterActive: classes.transitionEnterActive,
          exit: classes.transitionLeave,
          exitActive: classes.transitionLeaveActive,
        }}
        unmountOnExit
      >
        <Grid
          container
          className={classes.container}
          style={{ position: "absolute" }}
        >
          <Grid
            item
            xs={12}
            style={{ height: "30px", backgroundColor: "#474747" }}
          >
            <Header
              name={i18n.wbs.updateBudgetResources}
              updateResources={true}
            />
          </Grid>
          <Grid item xs={12} className={classes.tabBar}>
            <div style={{ marginLeft: 17 }}>
              <Tabs
                value={TakeOffStore.swipeTabComposition}
                onChange={this.handleTabChange}
                classes={{
                  root: classes.tabsRoot,
                  indicator: classes.tabsIndicator,
                }}
              >
                <Tab classes={tabClasses} label={"CONFIGURAÇÃO"} />
                <Tab
                  classes={tabClasses}
                  disabled={WBSStore.selectedComposition.id == undefined}
                  label={"REVISÃO DE ITENS"}
                />
              </Tabs>
            </div>
            <hr
              style={{
                width: "100%",
                position: "absolute",
                padding: 0,
                margin: 0,
                top: "79px",
              }}
            ></hr>
          </Grid>

          {TakeOffStore.takeOffLoading ? (
            <div
              style={{
                height: "calc(100vh - 183px)",
                display: "flex",
                alignItems: "center",
              }}
            >
              <CircularProgress
                size={50}
                style={{ margin: "0 auto", color: "#9FB408" }}
              />
            </div>
          ) : (
            <Grid
              item
              xs={12}
              className={classes.topBar}
              style={{ overflow: "hidden" }}
            >
              <SwipeableViews
                animateTransitions={false}
                axis={"x"}
                index={TakeOffStore.swipeTabComposition}
                disabled={true}
              >
                <TabContainer>
                  <UpdateBudgetResorcesTab1Edit />
                </TabContainer>
                <TabContainer>
                  <div
                    style={{
                      height: "calc(100vh - 113px)",
                      position: "relative",
                    }}
                  >
                    <UpdateBudgetResorcesTab2 />
                  </div>
                </TabContainer>
              </SwipeableViews>
              <Snackbar
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "left",
                }}
                open={TakeOffStore.openSnack}
                onClose={this.handleCloseSnack}
                ContentProps={{
                  "aria-describedby": "message-id",
                }}
                autoHideDuration={1000}
                message={<span id="message-id">{TakeOffStore.openSnack}</span>}
                action={[
                  <IconButton
                    key="close"
                    aria-label="close"
                    color="inherit"
                    onClick={this.handleCloseSnack}
                  >
                    <CloseIcon />
                  </IconButton>,
                ]}
              />
            </Grid>
          )}
        </Grid>
      </CSSTransition>
    );
  }
}

export default withStyles(styles)(UpdateBudgetResources);



// WEBPACK FOOTER //
// ./src/modules/WBS/components/layouts/UpdateBudgetResources.tsx